import update from "immutability-helper";
import cloneDeep from "lodash.clonedeep";
import { SET_LOCALE, FETCH_MESSAGES_SUCCESS } from "./index";


export const initialState = {
    locale: null,
    messages: new Map()
};

const setLocaleHandler = (state, action) => {
  return update(state, {
    locale: { $set: action.locale },
  });
};

const fetchMessagesSuccessHandler = (state, action) => {
  const { locale, messages } = action;
  let messagesStored = cloneDeep(state.messages);
  if (messagesStored.get(locale) === undefined) messagesStored.set(locale, messages);
  return update(state, {
    messages: { $set: messagesStored },
  });
};

export const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCALE:
      return setLocaleHandler(state, action);
    case FETCH_MESSAGES_SUCCESS:
      return fetchMessagesSuccessHandler(state, action);
    default:
      return state;
  }
};
